module.exports = __webpack_public_path__ + "static/media/Mike-Ahlers.53995ff4.jpg";